"use client";
import React from "react";
import { usePopperTooltip } from "react-popper-tooltip";
import Icon from "../../common/components/Icon";

const Tooltip = ({
  children,
  tooltip = undefined,
  hideArrow = false,
  title = "",
  description = null,
  fullwidth = false,
  showIconInTooltipMessage = false,
  ...props
}) => {
  const {
    getArrowProps,
    getTooltipProps,
    setTooltipRef,
    setTriggerRef,
    visible,
    placement,
  } = usePopperTooltip({
    ...props,
    offset: [0, 7],
    interactive: true,
    trigger: ["click", "hover"],
  });

  return (
    <div
      className={`trigger cursor-pointer position-relative ${fullwidth ? "full-width" : ""}`}
      ref={setTriggerRef}
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      <span>
        {children || <Icon icon="information-circle" fill="currentColor" />}
      </span>

      {visible && (
        <div
          ref={setTooltipRef}
          className={`tooltip-container border-radius z-high color-bg-white shadow p-3 ${props.type || ""}`}
          {...getTooltipProps()}
        >
          {!hideArrow && (
            <div
              className="tooltip-arrow"
              data-placement={placement || "auto"}
              {...getArrowProps()}
            />
          )}
          {props.type === "error" && (
            <div className="tooltip-icon">
              <Icon icon="road-sign-warning" fill="currentColor" />
            </div>
          )}
          <div>
            {!!title && <b className="mb-2 d-block">{title}</b>}
            <div
              className="d-flex justify-content-between align-items-start gap-2"
              style={{ width: "calc(100% - 0.5rem)" }}
            >
              {showIconInTooltipMessage && (
                <>
                  {children || (
                    <Icon
                      icon="information-circle"
                      className="icon--md"
                      fill="currentColor"
                    />
                  )}
                </>
              )}
              <span>{tooltip || description}</span>
            </div>
          </div>
          <button className="no-button position-absolute top-0 end-0 p-1 hide-on-not-mobile mt-2 me-2 color-bg-white">
            <Icon icon="close" className="icon--md" fill="currentColor" />
          </button>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
